import ConfigurationService from '../components/configuration/configuration.service'

const configurationService = new ConfigurationService()

const state = configurationService.getConfigData()

const getters = {

  isRecognized (state) {
    if (state.recognized) {
      return state.recognized
    }
    return false
  },

  recognizedIdToken (state) {
    return ((((state.recognized || {}).mastercard || {}).response || {}).idTokens || [])[0] || ''
  },

  environment (state) {
    return state.environment
  },

  srcClientId (state) {
    return state.checkout.srcClientId
  },

  srcDpaId (state) {
    return state.checkout.srcDpaId
  },

  srciTransactionId (state) {
    return state.checkout.srciTransactionId
  },

  dpaLocale (state) {
    return state.checkout.dpaLocale
  },

  cryptoType (state) {
    return state.checkout.cryptoType
  },

  srcKeys (state) {
    return state.checkout.keys
  },

  validationData (state) {
    return state.returningUser.validationData || null
  },

  consumerAuthorization (state) {
    return state.returningUser.consumerAuthorization || null
  },

  srcConsumerKey (state) {
    return state.checkout.srcConsumerKey
  },

  pemKey (state) {
    return state.checkout.pemKey
  },

  payloadRequestUrl (state) {
    return state.checkout.payloadRequestUrl
  },

  encKey (state) {
    return state.checkout.encKey
  },

  sdkJsUrl () {
    return state.sdkJsUrl
  },

  idToken () {
    return state.idToken
  },

  cardEncKey () {
    return state.cardEncKey
  }

}
const actions = {

  recognized ({ commit }, recognized) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('recognized', recognized)
        resolve()
      }, 100)
    })
  },

  changeEnvironment ({ commit }, environment) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('changeEnvironment', environment)
        resolve()
      }, 100)
    })
  },

  updateSrcClientId ({ commit }, srcClientId) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateSrcClientId', srcClientId)
        resolve()
      }, 100)
    })
  },
  updateSrcDpaId ({ commit }, dpaId) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateSrcDpaId', dpaId)
        resolve()
      }, 100)
    })
  },

  updateSrciTransactionId ({ commit }, srciTransactionId) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateSrciTransactionId', srciTransactionId)
        resolve()
      }, 100)
    })
  },

  updateDpaLocale ({ commit }, dpaLocale) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateDpaLocale', dpaLocale)
        resolve()
      }, 100)
    })
  },

  updateCryptoType ({ commit }, cryptoType) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateCryptoType', cryptoType)
        resolve()
      }, 100)
    })
  },

  updateKeysByEnv ({ commit }, srcKeys) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateKeysByEnv', srcKeys)
        resolve()
      }, 100)
    })
  },

  validationData ({ commit }, { result }) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('validationData', { result })
        resolve()
      }, 100)
    })
  },

  consumerAuthorization ({ commit }, { idToken }) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('consumerAuthorization', { idToken })
        resolve()
      }, 100)
    })
  },

  updatePemKey ({ commit }, pemKey) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updatePemKey', pemKey)
        resolve()
      }, 100)
    })
  },

  updateConsumerKey ({ commit }, srcConsumerKey) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateConsumerKey', srcConsumerKey)
        resolve()
      }, 100)
    })
  },

  updatePayloadRequestUrl ({ commit }, payloadRequestUrl) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setPayloadRequestUrl', payloadRequestUrl)
        resolve()
      }, 100)
    })
  },

  updateConfirmationRequestUrl ({ commit }, confirmationRequestUrl) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setConfirmationRequestUrl', confirmationRequestUrl)
        resolve()
      }, 100)
    })
  },

  updateEncKey ({ commit }, encKey) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateEncKey', encKey)
        resolve()
      }, 100)
    })
  },

  updateSdkJsUrl ({ commit }, sdkJsUrl) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setSdkJsUrl', sdkJsUrl)
        resolve()
      }, 100)
    })
  },

  updateidToken ({ commit }, idToken) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setIdToken', idToken)
        resolve()
      }, 100)
    })
  },

  updateCardEncKeyId ({ commit }, cardEncKey) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setCardEncKeyId', cardEncKey)
        resolve()
      }, 100)
    })
  }

}
const mutations = {

  recognized (state, recognized) {
    state.recognized = recognized
    configurationService.setConfigData(state)
  },

  changeEnvironment (state, environment) {
    state.environment = environment
    configurationService.setConfigData(state)
  },

  updateSrcClientId (state, srcClientId) {
    state.checkout.srcClientId = srcClientId
    configurationService.setConfigData(state)
  },

  updateSrcDpaId (state, dpaId) {
    state.checkout.srcDpaId = dpaId
    configurationService.setConfigData(state)
  },

  updateSrciTransactionId (state, srciTransactionId) {
    state.checkout.srciTransactionId = srciTransactionId
    configurationService.setConfigData(state)
  },

  updateDpaLocale (state, dpaLocale) {
    state.checkout.dpaLocale = dpaLocale
    configurationService.setConfigData(state)
  },

  updateCryptoType (state, cryptoType) {
    state.checkout.cryptoType = cryptoType
    configurationService.setConfigData(state)
  },

  updateKeysByEnv (state, srcKeys) {
    state.checkout.keys = srcKeys
  },

  validationData (state, result) {
    state.returningUser.validationData = result
    configurationService.setConfigData(state)
  },

  consumerAuthorization (state, idToken) {
    state.returningUser.consumerAuthorization = idToken
    configurationService.setConfigData(state)
  },

  updatePemKey (state, pemKey) {
    state.checkout.pemKey = pemKey
    configurationService.setConfigData(state)
  },

  updateConsumerKey (state, srcConsumerKey) {
    state.checkout.srcConsumerKey = srcConsumerKey
    configurationService.setConfigData(state)
  },

  setPayloadRequestUrl (state, payloadRequestUrl) {
    state.checkout.payloadRequestUrl = payloadRequestUrl
    configurationService.setConfigData(state)
  },

  setConfirmationRequestUrl (state, confirmationRequestUrl) {
    state.checkout.confirmationRequestUrl = confirmationRequestUrl
    configurationService.setConfigData(state)
  },

  updateEncKey (state, encKey) {
    state.checkout.encKey = encKey
    configurationService.setConfigData(state)
  },

  setSdkJsUrl (state, sdkJsUrl) {
    state.sdkJsUrl = sdkJsUrl
    configurationService.setConfigData(state)
  },

  setIdToken (state, idToken) {
    state.idToken = idToken
    configurationService.setConfigData(state)
  },

  setCardEncKeyId (state, cardEncKey) {
    state.cardEncKey = cardEncKey
    configurationService.setConfigData(state)
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}
